module.exports = __webpack_public_path__ + "static/media/vida.204e296a.jpg";